import { useEffect, useContext, useState } from "react";
import {Text, Link, VStack, Button,InfoOutlineIcon, HStack } from "native-base";
import { useLocation } from "react-router-dom";
import { getDocument } from "../utils/firebase/getDoc";
import { filterDataByPage } from "../utils";
import { ACTIONS, COLLECTION, EVENTS, PAGETYPE,PAGE_NAVIGATION } from "../constants";
import StyledButton from "../components/Button";
import StyledOutlinedButton from "../components/OutlinedButton";
import StyledImage from "../components/Image";
import {dispatchAnalyticsEvent,dispatchAnalyticsPageView} from '../utils'
import {decryptDigitalId,encryptData} from '../utils/decryptId'
import {ORG_ID} from '../constants/index'
import {useNavigate} from "react-router-dom";
import { AppContext } from '../context';
// import {fetchAnalyticsData} from '../utils/firebase/analytics';
function DressThreeHome(props) {
  const location = useLocation();
  const [getPageData, setPageData] = useState(null);
  const [getTheme, setTheme] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const orgId = queryParams.get("orgId");
  const encrypetdDigitalId = queryParams.get("digitalId");
  const digitalId= decryptDigitalId(encrypetdDigitalId)
  const styleId = queryParams.get("styleId");
  const lang = queryParams.get("lang");
  const style = queryParams.get("style");
  const MotifAmarezza = require("../images/amarezza/MotifAmarezza.png");
  const Amarezza2 = require("../images/amarezza/Amarezza2.png");
  const navigate = useNavigate();
  const { getData,getParams} = useContext(AppContext);


  const currentURL = window.location.href;
  // Use the URL constructor to parse the URL
  const urlObj = new URL(currentURL);

  // Extract the "la-makanerie" value from the pathname
  const pathnameParts = urlObj.pathname.split("/");
  
  const containerStyle = {
    width: '339px',
    height: '100px',
    //padding: '30px 113px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'cover',
    marginTop:'28px'
  };

  useEffect(() => {
    setPageData(filterDataByPage(getData, getParams.styleId, getParams.lang, PAGETYPE.home_page));
    // setTheme(filterDataByPage(getData, getParams.styleId, getParams.lang));
    dispatchAnalyticsPageView(location.pathname,PAGETYPE.home_page)
    // fetchAnalyticsData().catch(console.error);

  }, [getData]);
  const onSelect = (type) => {
    switch(type){
      case PAGETYPE.return:
        navigate(`${location.pathname}/${PAGETYPE.return}${location.search}`)
        window.gtag('event', EVENTS.RETURN, {
          'event_category': 'User Actions',
          'event_label': EVENTS.RETURN,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.RETURN,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.care:
        navigate(`${location.pathname}/${PAGETYPE.care}${location.search}`)
        window.gtag('event', EVENTS.CARE, {
          'event_category': 'User Actions',
          'event_label': EVENTS.CARE,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.CARE,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.upcycle:
          navigate(`${location.pathname}/${PAGETYPE.upcycle}${location.search}`)
          window.gtag('event', EVENTS.upcycle, {
            'event_category': 'User Actions',
            'event_label': EVENTS.upcycle,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.upcycle,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        break;
      case PAGETYPE.repair:
        navigate(`${location.pathname}/${PAGETYPE.repair}${location.search}`)
        window.gtag('event', EVENTS.REPAIR, {
          'event_category': 'User Actions',
          'event_label': EVENTS.REPAIR,
          'value': JSON.stringify({
            digitalId:getParams.digitalId,
            category:EVENTS.REPAIR,
            styleId: getParams.styleId,
            style:getParams.style,
            lang:getParams.lang
          }) 
        });
        break;
      case PAGETYPE.resale:
          navigate(`${location.pathname}/${PAGETYPE.resale}${location.search}`)
          window.gtag('event', EVENTS.RESALE, {
            'event_category': 'User Actions',
            'event_label': EVENTS.RESALE,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.RESALE,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        break;
      case ACTIONS.OPEN_MAIL:
          window.location.href = `mailto:${location.pathname === '/a-new-sweden'? 'help@anewsweden.com' : location.pathname === '/la-makanerie'? 'contact@la-makanerie.com': 'elizabeth@hellomadi.com'} `
          window.gtag('event', EVENTS.HELP_AND_CONTACT, {
            'event_category': 'User Actions',
            'event_label': EVENTS.HELP_AND_CONTACT,
            'value': JSON.stringify({
              digitalId:getParams.digitalId,
              category:EVENTS.HELP_AND_CONTACT,
              styleId: getParams.styleId,
              style:getParams.style,
              lang:getParams.lang
            }) 
          });
        
        break;
      default:
        navigate(`${location.pathname}`)
        break;
    }
  }
  return (
    <>
      {getPageData && (
        <>
          <VStack alignItems="center" justifyContent="center" space={2} py={"1"} marginTop={"10px"}>
          <a href={getPageData?.url} target="_blank" rel="noopener noreferrer">
          <div style={containerStyle}>  
        <img width={ pathnameParts[1] === 'la-makanerie' && ORG_ID.includes(orgId) ? '35%' : '50%'} src={getPageData.data.images?.logo} alt="Responsive" style={imageStyle} />
         </div>
         </a>
          </VStack>
          <VStack alignItems="center" marginBottom={"4"} px={4} space={"6"} marginTop={"20px"}>
            <Text fontSize={getPageData?.theme?.fontSize.small} fontFamily={getPageData?.theme?.fontFamily.secondary}>
              {getPageData?.data.brandLabel}
            </Text>
          </VStack>
          <VStack alignItems="center" px= {"0"}>
          <img 
          width={'85%'}
          src={ style === "amarezza"
                    ? MotifAmarezza
                    : getPageData.data.images?.primary} alt="Responsive" style={imageStyle} />
          </VStack>
          <VStack alignItems={"center"} py={'5'}>
    <HStack spacing={2} alignItems="center">
    <Text 
      color={getPageData?.theme?.color.primary}
      fontSize={getPageData?.theme?.fontSize.xs} 
      mr="5px"
      fontFamily={getPageData?.theme?.fontFamily.primary}>
      {getPageData?.data.authLabel}
    </Text>
    <InfoOutlineIcon
      color={getPageData?.theme?.color.primary}
      fontSize="xs"
      height="9px"
      width="9px"
    />
  </HStack>
            <Text 
             color={getPageData?.theme?.color.primary}
             fontSize={getPageData?.theme?.fontSize.xl} 
             fontFamily={getPageData?.theme?.fontFamily.secondary}
             textAlign="center" 
            >
              {getPageData?.data.descriptionMainStyle}
            </Text>
            <Text  
                  fontWeight={getPageData?.theme?.fontWeight.light}
                 color={getPageData?.theme?.color.primary}
                 fontSize={getPageData?.theme?.fontSize.xs} 
                 fontFamily={getPageData?.theme?.fontFamily.primary}
            >
              {` ${getPageData?.data.digitalId}: ${digitalId}`}
            </Text>
          </VStack>
          <VStack alignItems="center" >
          <img  src={style === "amarezza" ? Amarezza2 : getPageData.data.images?.secondary} alt="Responsive" style={imageStyle} />
          </VStack>
          <VStack alignItems="flex-start" px={4} py={4} space={4}>
            <Text 
             color={getPageData?.theme?.color.primary}
             fontWeight={getPageData.theme.fontWeight.light}
             fontSize={getPageData?.theme?.fontSize.xl} 
             fontFamily={
              getPageData?.theme?.fontFamily.secondary}
            >
              {getPageData.data.secondTitle}
            </Text>
            <Text
             color={getPageData?.theme?.color.primary}
             fontSize={getPageData?.theme?.fontSize.small} fontFamily={getPageData?.theme?.fontFamily.primary}
            >
              {getPageData.data.descriptionSecondaryStyle}
            </Text>
            <Link
              href={`${location.pathname}/supplyChain${location.search}`}
              width={"full"}>
              <Text color={getPageData?.theme?.color.primary}
             fontSize={getPageData?.theme?.fontSize.small} fontFamily={getPageData?.theme?.fontFamily.primary}>
                {getPageData?.data.productHistory} →
              </Text>
            </Link>
          </VStack>

          <VStack
            alignItems="center"
            space={2}
            marginBottom={7}
            mx={4}
            fontFamily={getPageData.theme?.fontFamily.secondary}
          >
            {/* <Link
              href={`/la-makanerie/return${location.search}`}
              width={"full"}
            > */}
              <StyledOutlinedButton
                fontFamily={getTheme?.theme?.fontFamily?.primary}
                onClick={()=>onSelect(PAGETYPE.return)}
                backgroundColor="transparent"                
                borderColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}

                width="100%"
                height="54px"
                text={getPageData.data.returnsExchanges}
              />
            {/* </Link> */}
            {/* <Link href={`/la-makanerie/care${location.search}`} width={"full"}> */}
              <StyledOutlinedButton
                backgroundColor="transparent"
                borderColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
                width="100%"
                height="54px"
                text={getPageData?.data.interview}
                onClick={()=>onSelect(PAGETYPE.care)}
              />
            {/* </Link> */}
          </VStack>
          <VStack alignItems="center" space={2} mx={4} marginBottom={5}>
            {/* <Link
              href={`/la-makanerie/repair${location.search}`}
              width={"full"}
            > */}
              <StyledOutlinedButton
                onClick={()=>onSelect(PAGETYPE.repair)}
                fontFamily={getTheme?.theme?.fontFamily?.primary}
                backgroundColor="transparent"
                borderColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}

                // textColor={getTheme?.theme?.color?.primary}
                // borderColor={getTheme?.theme?.color?.primary}
                width="100%"
                height="54px"
                text={getPageData?.data.retoucher}
              />
            {/* </Link> */}
            {/* <Link
              href={`/la-makanerie/resale${location.search}`}
              width={"full"}
            > */}
              <StyledOutlinedButton
               onClick={()=>onSelect(PAGETYPE.resale)}
                backgroundColor="transparent"
                borderColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
                // textColor={getTheme?.theme?.color?.primary}
                // borderColor={getTheme?.theme?.color?.primary}
                width="100%"
                height="54px"
                text={getPageData?.data.resell}
              />
            {/* </Link> */}
            {/* <Link
              href={`/la-makanerie/upcycle${location.search}`}
              width={"full"}
            > */}
              <StyledOutlinedButton
                onClick={()=>onSelect(PAGETYPE.upcycle)}
                backgroundColor="transparent"
                borderColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
                // textColor={getTheme?.theme?.color?.primary}
                // borderColor={getTheme?.theme?.color?.primary}
                width="100%"
                height="54px"
                text={getPageData?.data.upcycle}
              />
            {/* </Link> */}
            {/* <Link href="mailto:contact@la-makanerie.com" width={"full"}> */}
              <StyledButton
                onClick={()=> onSelect(ACTIONS.OPEN_MAIL)}
                text={getPageData?.data.contact}
                backgroundColor= { style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                getPageData?.theme?.color?.primary}

                backgroundColor={ style ==='jamtland' ?"#1341B6":
                style ==='ans'?  getPageData?.theme?.color?.secondary:
                style === 'acqua' ? "#882517":
                style === 'amarezza'? "#DBA359":
                getPageData?.theme?.color?.primary}
              
                textColor="#FFFFFF"
                borderColor="transparent"
                width="100%"
                height="54px"
                hoverBackgroundColor="#FFFFFF"
                hoverTextColor={
                  style ==='jamtland' ?"#1341B6":
                  style ==='ans'?  getPageData?.theme?.color?.secondary:
                  style === 'acqua' ? "#882517":
                  style === 'amarezza'? "#DBA359":
                  getPageData?.theme?.color?.primary}
                hoverBorderColor={
                  style ==='jamtland' ?"#1341B6":
                  style ==='ans'?  getPageData?.theme?.color?.secondary:
                  style === 'acqua' ? "#882517":
                  style === 'amarezza'? "#DBA359":
                  getPageData?.theme?.color?.primary}
              />
            {/* </Link> */}
          </VStack>
        </>
      )}
    </>
  );
}

export default DressThreeHome;
